import { ColorPickerAction, IColorPickerState } from './color-picker.types';
import produce from 'immer';
import { COLOR_PICKER_CHANGE_COLOR } from './color-picker.actions';

export const colorPickerInitialState: IColorPickerState = {
	color: '#000000'
};

export function colorPickerReducer(
	state: IColorPickerState = colorPickerInitialState,
	action: ColorPickerAction
): IColorPickerState {
	switch (action.type) {
		case COLOR_PICKER_CHANGE_COLOR: {
			return changeColor(state, action.payload as string);
		}
		default: {
			return state;
		}
	}
}

function changeColor(
	currentState: IColorPickerState,
	color: string
): IColorPickerState {
	return produce(currentState, (draftState: IColorPickerState) => {
		draftState.color = color;
	});
}
